import {Buttons, ResultFormStyle} from "./Success";
import {Images} from "../../utils/images";
import {H2, H5, P1} from "../shared/fonts/fonts";
import {ButtonPU} from "../shared/buttons/buttons";
import User from "../../entities/User";
import React from "react";
import Loading from "../shared/form/loading";
import {URLs} from "../../utils/constants";
import {Message} from "../shared/calendar/Card";

const Waiting = () => {
  return (
    <ResultFormStyle>
      <Loading />
      <H2>Проверка платежа</H2>
      <P1>Ожидаем информацию о платеже от банка. Проверка займет не более 1 минуты. Как только узнаем статус платежа, страница обновится сама.</P1>
      <Buttons>
        <Message href={URLs.chat}>
          <img src={Images.icons.message_blue}/>Помощь
        </Message>
        <ButtonPU href={User.linkToView()}><H5>Личный кабинет</H5></ButtonPU>
      </Buttons>
    </ResultFormStyle>
  );
};

export default Waiting;